import React, { useState, useEffect, useRef  } from 'react';
import { Link } from "react-router-dom";

import logoDark from "../assets/images/logo-dark.svg"
import logoLight from "../assets/images/logo-light.svg"
import logoWhite from "../assets/images/logo-white.svg"
import userImg from '../assets/images/client/16.jpg'

import {FiSearch, FiUser, FiMail} from '../assets/icons/vander'
import { fetchDestinations } from "../services/api";

const adventureSections = [
    {
        title: "Aventura",
        items: [
            { label: "Senderismo y Trekking", to: "/grid/trekking" },
            { label: "Rafting y Kayak", to: "/grid/rafting" },
            { label: "Cicloturismo", to: "/grid/bicicleta" },
            { label: "Overland / 4x4", to: "/grid/overland" },
            { label: "Explorador", to: "/grid/explorer" },
        ],
    },
    {
        title: "Cultura y Ciudad",
        items: [
            { label: "Cultural", to: "/grid/cultural" },
            { label: "Gastronomía", to: "/grid/culinario" },
            { label: "Festivales y Eventos", to: "/grid/festivales" },
            { label: "Bienestar y Spa", to: "/grid/wellness" },
        ],
    },
    {
        title: "Naturaleza",
        items: [
            { label: "Cruceros Fluviales", to: "/grid/cruceros-fluviales" },
            { label: "Safari", to: "/grid/safari" },
            { label: "Navegación", to: "/grid/navegacion" },
            { label: "Montaña y Nevados", to: "/grid/montana" },
        ],
    },
];

const slugify = (str = '') =>
    str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g,'')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g,'-')
        .replace(/(^-|-$)/g,'');

export default function Navbar({navclass, navlight, manuclass}){
    let [scrolling, setScrolling] = useState(false);
    let [isToggle, setToggle] = useState(false);
    let [manu , setManu] = useState('');
    let [subManu , setSubManu] = useState('');
    let [isOpen, setIsOpen] = useState(false);
    let [userManu, setUserManu] = useState(false);
    const [destSections, setDestSections] = useState([]);

    let dropdownRef = useRef(null);
    let userRef = useRef(null)

    useEffect(()=>{
        const handleScroll = () => {
            const isScrolling = window.scrollY > 50;
            setScrolling(isScrolling);
        };

        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
              setIsOpen(false);
            }
          };

        const userOutsideClick = (e) =>{
            if(userRef.current && !userRef.current.contains(e.target)){
                setUserManu(false)
            }
        }

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('click', handleOutsideClick);
        window.addEventListener('click', userOutsideClick);
        
        let current = window.location.pathname
        setManu(current)
        setSubManu(current)
        window.scrollTo(0, 0);

        fetchDestinations()
            .then((data)=>{
                const grouped = data.reduce((acc, dest)=>{
                    const title = dest.region || dest.country || dest.name;
                    if(!acc[title]) acc[title] = new Set();
                    if(dest.city) acc[title].add(dest.city);
                    return acc;
                }, {});
                const sections = Object.entries(grouped).map(([title, citiesSet])=>({
                    title,
                    items: Array.from(citiesSet).map((city)=>({
                        label: city,
                        to: `/grid/${slugify(city)}`,
                    })),
                })).sort((a,b)=>a.title.localeCompare(b.title));
                setDestSections(sections);
            })
            .catch((err)=>console.error("Destinations fetch error", err));

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('click', handleOutsideClick);
            window.removeEventListener('click', userOutsideClick);
          };
    },[])

    const toggleMenu = () =>{
        setToggle(!isToggle)
      }

    const isItemActive = (item) => (item.activePaths || []).includes(manu);

    const hasOpenChild = (children = []) => {
        return children.some((child) => child.id === subManu || (child.children && hasOpenChild(child.children)));
    }

    const isSubMenuOpen = (item) => {
        if(item.megaSections && item.megaSections.length){
            return subManu === item.id;
        }
        if(!item.children || !item.children.length) return false;
        return (item.activePaths || []).includes(subManu) || subManu === item.id || hasOpenChild(item.children);
    }

    const handleSubMenuToggle = (e, id) => {
        e.preventDefault();
        setSubManu(subManu === id ? '' : id);
    }

    // Solo rutas vivas: se retiraron los menús a páginas de plantilla no ruteadas
    // (listado con sidebars, tour list, blog, cuenta de usuario, helpcenter, auth,
    // páginas especiales), coherente con el router en App.js.
    const menuItems = [
        {
            id: 'destinations',
            label: 'Destinos',
            activePaths: ['/grid'],
            megaSections: destSections,
            megaTitle: 'Destinos por región',
        },
        {
            id: 'adventure',
            label: 'Estilos de aventura',
            activePaths: ['/grid'],
            megaSections: adventureSections,
            megaTitle: 'Estilos de aventura',
        },
        { id: 'tours', label: 'Tours', to: '/grid', activePaths: ['/grid'] },
        { id: 'aboutus', label: 'Nosotros', to: '/aboutus', activePaths: ['/aboutus'] },
        {
            id: 'utility',
            label: 'Legal',
            parentClass: 'parent-parent-menu-item',
            activePaths: ['/terms','/privacy'],
            children: [
                { label: 'Términos y Condiciones', to: '/terms', activePaths: ['/terms'] },
                { label: 'Política de Privacidad', to: '/privacy', activePaths: ['/privacy'] },
            ],
        },
        { id: 'contact', label: 'Contacto', to: '/contact', activePaths: ['/contact'] },
    ];

    const renderMenuItems = (items, level = 0) => {
        return items.map((item)=> {
            const hasChildren = item.children && item.children.length > 0;
            const hasMega = item.megaSections && item.megaSections.length > 0;
            const open = isSubMenuOpen(item);
            const active = isItemActive(item);
            const liClasses = ['relative'];

            if(hasChildren || hasMega){
                liClasses.push('has-submenu');
                liClasses.push(item.parentClass ? item.parentClass : 'parent-menu-item');
            }

            if(active){
                liClasses.push('active');
            }

            const arrowClass = level === 0 ? 'menu-arrow' : 'submenu-arrow';

            return(
                <li
                    key={item.id || item.to}
                    className={liClasses.join(' ')}
                    onMouseEnter={()=> hasMega && setSubManu(item.id)}
                >
                    {hasMega ? (
                        <>
                            <Link to="#" role="button" aria-haspopup="menu" aria-expanded={open} onClick={(e)=>handleSubMenuToggle(e, item.id)}>{item.label}</Link><span className={arrowClass}></span>
                            {open && (
                                <div
                                    className="absolute left-1/2 -translate-x-1/2 top-full lg:mt-4 mt-2 w-[92vw] max-w-4xl bg-white dark:bg-slate-900 rounded-md shadow-lg dark:shadow-gray-800 p-6 border border-gray-100 dark:border-gray-800 z-50"
                                    onMouseEnter={()=>setSubManu(item.id)}
                                    onMouseLeave={()=>setSubManu('')}
                                >
                                    <h5 className="text-lg font-semibold mb-4">{item.megaTitle || item.label}</h5>
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
                                        {item.megaSections.map((section)=>(
                                            <div key={section.title}>
                                                <p className="font-semibold mb-2">{section.title}</p>
                                                <ul className="space-y-1 text-sm">
                                                    {section.items.map((place)=>(
                                                        <li key={`${section.title}-${place.label}`}>
                                                            <Link to={place.to} className="hover:text-red-500" onClick={()=>setSubManu('')}>{place.label}</Link>
                                                        </li>
                                                    ))}
                                                    {section.seeAll && (
                                                        <li className="mt-2">
                                                            <Link to={section.seeAll} className="text-red-500 font-semibold hover:underline" onClick={()=>setSubManu('')}>Ver todos</Link>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    ) : hasChildren ? (
                        <>
                            <Link to="#" role="button" aria-haspopup="menu" aria-expanded={open} onClick={(e)=>handleSubMenuToggle(e, item.id)}>{item.label}</Link><span className={arrowClass}></span>
                            <ul className={`submenu ${open ? 'open' : ''}`}>
                                {renderMenuItems(item.children, level + 1)}
                            </ul>
                        </>
                    ) : (
                        <Link to={item.to} className="sub-menu-item">{item.label}</Link>
                    )}
                </li>
            )
        })
    }

    return(
        <nav id="topnav" className={`${navclass} ${scrolling ? 'nav-sticky' : ''}`}>
            <div className="container relative">
                {navlight && (
                    <Link className="logo" to="/">
                        <span className="inline-block dark:hidden">
                            <img src={logoDark} className="h-7 l-dark" alt="Chile Turismo — inicio"/>
                            <img src={logoLight} className="h-7 l-light" alt="Chile Turismo — inicio"/>
                        </span>
                        <img src={logoWhite} className="hidden dark:inline-block" alt="Chile Turismo — inicio"/>
                    </Link>
                )}
                {!navlight && (
                    <Link className="logo" to="/">
                        <div>
                            <img src={logoDark} className="h-7 inline-block dark:hidden" alt="Chile Turismo — inicio"/>
                            <img src={logoWhite} className="h-7 hidden dark:inline-block" alt="Chile Turismo — inicio"/>
                        </div>
                    </Link>
                )}

                <div className="menu-extras">
                    <div className="menu-item">
                        <button type="button" className={`navbar-toggle ${isToggle ? 'open' : ''}`} id="isToggle" aria-label={isToggle ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isToggle} onClick={() =>toggleMenu()}>
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>
                    </div>
                </div>

                <ul className="buy-button list-none mb-0 space-x-1">
                    {navlight === true ? (
                        <li className="dropdown inline-block relative pe-1" ref={dropdownRef}>
                            <button className="dropdown-toggle align-middle inline-flex search-dropdown" type="button" aria-label="Buscar" aria-expanded={isOpen} onClick={()=>setIsOpen(!isOpen)}>
                                <FiSearch className="size-5 dark-icon"></FiSearch>
                                <FiSearch className="size-5 white-icon text-white"></FiSearch>
                            </button>
                            {isOpen && (
                                <div className="dropdown-menu absolute overflow-hidden end-0 m-0 mt-5 z-10 md:w-52 w-48 rounded-md bg-white dark:bg-slate-900 shadow dark:shadow-gray-800">
                                    <div className="relative">
                                        <FiSearch className="size-4 absolute top-[9px] end-3"></FiSearch>
                                        <label htmlFor="searchItemLight" className="sr-only">Buscar</label>
                                        <input type="text" className="h-9 px-3 pe-10 w-full border-0 outline-none bg-white dark:bg-slate-900" name="s" id="searchItemLight" aria-label="Buscar" placeholder="Buscar…"/>
                                    </div>
                                </div>
                            )}
                        </li>
                    ) : (

                        <li className="dropdown inline-block relative pe-1" ref={dropdownRef}>
                            <button className="dropdown-toggle align-middle inline-flex search-dropdown" type="button" aria-label="Buscar" aria-expanded={isOpen} onClick={()=>setIsOpen(!isOpen)}>
                                <FiSearch className="size-5"></FiSearch>
                            </button>
                            {isOpen && (
                                <div className="dropdown-menu absolute overflow-hidden end-0 m-0 mt-5 z-10 md:w-52 w-48 rounded-md bg-white dark:bg-slate-900 shadow dark:shadow-gray-800">
                                    <div className="relative">
                                        <FiSearch className="size-4 absolute top-[9px] end-3"></FiSearch>
                                        <label htmlFor="searchItemDark" className="sr-only">Buscar</label>
                                        <input type="text" className="h-9 px-3 pe-10 w-full border-0 outline-none bg-white dark:bg-slate-900" name="s" id="searchItemDark" aria-label="Buscar" placeholder="Buscar…"/>
                                    </div>
                                </div>
                            )}
                        </li>
                    )}

            
                    <li className="dropdown inline-block relative ps-0.5" ref={userRef}>
                        <button className="dropdown-toggle items-center" type="button" aria-label="Menú de usuario" aria-haspopup="menu" aria-expanded={userManu} onClick={()=>setUserManu(!userManu)}>
                            <span className="size-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-md border border-red-500 bg-red-500 text-white"><img src={userImg} className="rounded-md" alt=""/></span>
                        </button>
                        {userManu && (
                            <div className="dropdown-menu absolute end-0 m-0 mt-4 z-10 w-48 rounded-md overflow-hidden bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 ">
                                <ul className="py-2 text-start">
                                    <li>
                                        <Link to="/" className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-red-500 dark:hover:text-white"><FiUser className="size-4 me-2"></FiUser>Inicio</Link>
                                    </li>
                                    <li>
                                        <Link to="/grid" className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-red-500 dark:hover:text-white"><FiSearch className="size-4 me-2"></FiSearch>Tours</Link>
                                    </li>
                                    <li className="border-t border-gray-100 dark:border-gray-800 my-2"></li>
                                    <li>
                                        <Link to="/contact" className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-red-500 dark:hover:text-white"><FiMail className="size-4 me-2"></FiMail>Contacto</Link>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </li>
                </ul>

                <div id="navigation" style={{display: isToggle === true ? 'block' : 'none'}}>
                    <ul className={`navigation-menu ${manuclass}`}>
                        {renderMenuItems(menuItems)}
                    </ul>
                </div>
            </div>
        </nav>
    )
}
